import React from 'react';
import { Link } from 'react-router-dom';

export default function Disclosures() {
  return (
    <div>
      {/* Header Start */}
      <div className="container-fluid hero-header bg-light py5 mb5">
        <div className="container py-5">
          <div className="row g-5 align-items-center">
            <div className="col-lg-12">
              <h1 className="display-4 mb-3 animated slideInDown">
                Disclosures under Regulation 46 of SEBI (LODR) Regulation, 2015
              </h1>
              <nav aria-label="breadcrumb" className="animated slideInDown">
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                  <li className="breadcrumb-item"><Link to="/investor-relation">Investor Relation</Link></li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Disclosures under Regulation 46 of SEBI (LODR) Regulation, 2015
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
      {/* Header End */}

      {/* About Start */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="table-responsive table_heading">
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th className="text-left">Particulars</th>
                  </tr>
                </thead>
                <tbody>
				 <tr>
                        <td><Link to="/about">Details of its business</Link></td>
                        </tr>  <tr>
                        <td><Link to="/moa-aoa">Memorandum of Association and Articles of Association</Link></td>
                        </tr> 
                        <tr>
                        <td><Link to="/board-of-director">Brief profile of board of directors including directorship</Link></td>
                        </tr> 
                        <tr>
                        <td><Link target="_blank" to="/codes-policies/Code-of-Independent-Directors-and-Terms-and-Conditions-for-their-Appointment.pdf">Terms and conditions of appointment of independent directors</Link></td>
                        </tr> 
                        <tr>
                        <td><Link target="_blank" to="/committees-of-board">Committees of board of directors</Link></td>
                        </tr> 
                        <tr>
                        <td><Link target="_blank" to="/codes-policies/Code-of-Conduct-for-Board-of-Directors-and-Senior-Management.pdf">Code of Conduct </Link></td>
                        </tr> 
                        <tr>
                        <td><Link target="_blank" to="/codes-policies/Whistle-Blower-Policy.pdf">Vigil Mechanism/ Whistle Blower policy</Link></td>
                        </tr>
                        
                         <tr>
                        <td><Link target="_blank" to="/codes-policies/criteria-to-making-payment-to-Non-Executive-Directors.pdf">Criteria of making payments to non-executive directors</Link></td>
                        </tr>
                         <tr>
                        <td><Link target="_blank" to="/codes-policies/Policy-on-Materiality-of-RPTs.pdf">Related party transactions policy</Link></td>
                        </tr>
                         <tr>
                        <td><Link target="_blank" to="/codes-policies/Details-of-familiarization-programmes-imparted-to-independent-directors.pdf">Familiarization programmes imparted to independent directors </Link></td>
                        </tr>
                         <tr>
                        <td><Link to="/contact">Email Address for grievance redressal</Link></td>
                        </tr>
                        <tr>
                        <td><Link to="/contact">Email address for investor grievances</Link></td>
                        </tr>
                         <tr>
                        <td> <h6 style={{ color: "black" }}>Financial information</h6>
						  <ol>
							<li><Link to="/notice-of-board-meeting">Notice of meeting of the board of directors</Link></li>
							<li>
							  <Link to="/financial-result">
								Financial results
							  </Link>
							</li>
							<li>
							  <Link to="/annual-reports">
								Annual report
							  </Link>
							</li>
						  </ol>
						</td>
                        </tr>
                         <tr>
                        <td><Link to="/shareholding-pattern">Shareholding Pattern</Link></td>
                        </tr>
                         <tr>
                        <td><Link to="/press-release-&-announcement" target="_blank">Regulation 47(1)</Link></td>
                        </tr>
                         <tr>
                        <td><Link to="/annual-secretarial-compliance-report">Secretarial Compliance Report</Link></td>
                        </tr>
                         <tr>
                        <td><Link target="_blank" to="/codes-policies/Policy-on-determining-of-Materiality-of-events-and-info.pdf">Policy for determination of materiality of events or information</Link></td>
                        </tr>
                         <tr>
                        <td><Link target="_blank"  to="/regulation-30">disclosures under sub-regulation (8) of regulation 30 of these regulation</Link></td>
                        </tr>
						
						<tr>
                        <td><Link to="/annual-return">Annual return</Link></td>
                        </tr>

						<tr>
                        <td><Link target="_blank" to="/contact">Contact details of personnel authorised to determine materiality of event and information</Link></td>
                        </tr>
						<tr>
							<td> <h6 style={{ color: "black" }}>contact details of key managerial personnel under sub-regulation (5) of regulation 30 SEBI LODR</h6>
							  <ul>
								<li>Name : Ishant Malhotra</li>
								<li>Designation: Managing Director</li>
								<li>Contact Details: info@kalpacommercialltd.com</li>
							  </ul>
							</td>
                        </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {/* About End */}
    </div>
  );
}
